export default [
  {
    header: '',
    children: [
      {
        title: 'Bảng điều khiển',
        icon: 'HomeIcon',
        route: 'dashboard',
        action: 'dashboard.show',
        resource: 'Dashboard',
      },
      // {
      //   title: 'Chat',
      //   icon: 'MessageSquareIcon',
      //   route: 'chat-list',
      //   action: 'chat.index',
      //   resource: 'Chat',
      // },
    ],
  },
  {
    header: 'Thống kê',
    children: [
      {
        title: 'Thống kê tin bài',
        icon: 'PieChartIcon',
        resource: 'Report',
        action: null,
        children: [
          {
            title: 'Thống kê theo đơn vị',
            route: 'report-unit',
            action: 'report.unit',
            resource: 'Report',
          },
          {
            title: 'Thống kê theo ban',
            route: 'report-department',
            action: 'report.department',
            resource: 'Report',
          },
          {
            title: 'Thống kê theo phòng',
            route: 'report-member',
            action: 'report.member',
            resource: 'Report',
          },
          {
            title: 'Thống kê cá nhân',
            route: 'report-owner',
            action: 'report.owner',
            resource: 'Report',
          },
        ],
      },
    ],
  },
  {
    header: 'News',
    children: [
      {
        title: 'Biên tập',
        icon: 'FileTextIcon',
        action: null,
        resource: 'Article',
        children: [
          {
            title: 'Tạo bài viết',
            route: 'article-create',
            action: 'article.create',
            resource: 'Article',
          },
          {
            title: 'Tin của tôi',
            route: 'article-private',
            action: 'article.private',
            resource: 'Article',
            tag: 0,
            tagVariant: 'danger',
            tagId: 'news_total_privated',
            tagShow: true,
          },
          {
            title: 'Tin nhờ xử lý',
            route: 'article-draft',
            action: 'article.draft',
            resource: 'Article',
            tag: 0,
            tagVariant: 'danger',
            tagId: 'news_total_draft',
            tagShow: true,
          },
          {
            title: 'Tin đã xử lý',
            route: 'article-processed',
            action: 'article.processed',
            resource: 'Article',
          },
        ],
      },
      {
        title: 'Quản lý tin',
        icon: 'ListIcon',
        action: null,
        resource: 'Article',
        children: [
          {
            title: 'Tin chờ duyệt',
            route: 'article-approved',
            action: 'article.approved',
            resource: 'Article',
            tag: 0,
            tagVariant: 'danger',
            tagId: 'news_total_approved',
            tagShow: true,
          },
          {
            title: 'Tin chờ xuất bản',
            route: 'article-corrected',
            action: 'article.corrected',
            resource: 'Article',
            tag: 0,
            tagVariant: 'danger',
            tagId: 'news_total_corrected',
            tagShow: true,
          },
          {
            title: 'Tin hủy xuất bản',
            route: 'article-archived',
            action: 'article.archived',
            resource: 'Article',
          },
          {
            title: 'Tin đã xóa',
            route: 'article-deleted',
            action: 'article.deleted',
            resource: 'Article',
          },
          {
            title: 'Tin đã xuất bản',
            route: 'article-published',
            action: 'article.published',
            resource: 'Article',
          },
          {
            title: 'Tin nội bộ',
            route: 'article-internal',
            action: 'article.internal',
            resource: 'Article',
          },
          {
            title: 'Tác phẩm xuất sắc',
            route: 'article-excellent',
            action: 'article.excellent',
            resource: 'Article',
          },
        ],
      },
      {
        title: 'Thiết lập',
        icon: 'SettingsIcon',
        action: null,
        resource: [
          'Category',
          'Tags',
          'Propagate',
          'Collection',
          'State',
          'Workflow',
          'WorkflowTransition',
        ],
        children: [
          {
            title: 'Category',
            route: 'category-list',
            action: 'category.index',
            resource: 'Category',
          },
          {
            title: 'Article Type',
            route: 'article-type-list',
            action: 'articleType.index',
            resource: 'ArticleType',
          },
          {
            title: 'Tags',
            route: 'tags-list',
            action: 'tags.index',
            resource: 'Tags',
          },
          {
            title: 'Chỉ đạo thông tin',
            route: 'propagate-list',
            action: 'propagate.index',
            resource: 'Propagate',
          },

          {
            title: 'Quy trình sản xuất',
            action: null,
            resource: ['Collection', 'State', 'Workflow', 'WorkflowTransition'],
            children: [
              // {
              //   title: 'Nhóm danh mục',
              //   route: 'collection-list',
              //   action: 'collection.index',
              //   resource: 'Collection',
              // },
              {
                title: 'Trạng thái',
                route: 'state-list',
                action: 'state.index',
                resource: 'State',
              },
              {
                title: 'Chuyển trạng thái',
                route: 'workflow-transition-list',
                action: 'workflowTransition.index',
                resource: 'WorkflowTransition',
              },
              {
                title: 'Luồng xử lý tin bài',
                route: 'workflow-list',
                action: 'workflow.index',
                resource: 'Workflow',
              },
            ],
          },
        ],
      },
      {
        title: 'Bình luận',
        icon: 'MessageSquareIcon',
        route: 'comment-list',
        action: 'comment.index',
        resource: 'Comment',
      },
      {
        title: 'Thu thập tin tức',
        icon: 'RssIcon',
        action: '',
        children: [
          {
            title: 'Kênh liên kết',
            route: 'crawler-config-list',
            action: 'crawlerConfig.index',
            resource: 'CrawlerConfig',
          },
          {
            title: 'Tin thu thập',
            route: 'crawler-list',
            action: 'crawler.index',
            resource: 'Crawler',
          },
          {
            title: 'Thống kê tin thu thập',
            route: 'crawler-statistic',
            action: 'crawler.statistic',
            resource: 'Crawler',
          },
          {
            title: 'Thống kê tin đã tạo',
            route: 'crawler-processed',
            action: 'crawler.processed',
            resource: 'Crawler',
          },
        ],
      },
      {
        title: 'Chương trình thu ghi',
        icon: 'CastIcon',
        action: '',
        children: [
          {
            title: 'Danh mục kênh',
            route: 'channel-category-list',
            action: 'channelCategory.index',
            resource: 'ChannelCategory',
          },
          {
            title: 'Nhóm kênh',
            route: 'channel-group-list',
            action: 'channelGroup.index',
            resource: 'ChannelGroup',
          },
          {
            title: 'Luồng trực tuyến',
            route: 'channel-list',
            action: 'channel.index',
            resource: 'Channel',
          },
          {
            title: 'Lịch phát sóng',
            route: 'schedule-list',
            action: 'schedule.index',
            resource: 'Schedule',
          },
          {
            title: 'Lịch ghi tự động',
            route: 'channel-schedule-list',
            action: 'channelSchedule.index',
            resource: 'ChannelSchedule',
          },
          {
            title: 'Danh sách thu ghi',
            route: 'schedule-item-list',
            action: 'channelSchedule.scheduleItem',
            resource: 'ChannelSchedule',
          },
          {
            title: 'Thống kê thu ghi',
            route: 'schedule-statistic',
            action: 'channelSchedule.scheduleStatistic',
            resource: 'ChannelSchedule',
          },
        ],
      },
      {
        title: 'Nhuận bút',
        icon: 'ColumnsIcon',
        action: '',
        children: [
          {
            title: 'Tổng hợp bảng năng suất',
            route: 'profits-list',
            action: 'profits.list',
            resource: 'Profits',
          },
          {
            title: 'Chấm điểm nhuận bút',
            route: 'profits-list-approve',
            action: 'profits.list_approve',
            resource: 'Profits',
          },
        ],
      },
      {
        title: 'Kế hoạch tin bài ',
        icon: 'AirplayIcon',
        action: '',
        children: [
          {
            title: 'Danh mục chương trình',
            route: 'program-list',
            action: 'register_plans.program_list',
            resource: 'RegisterPlan',
            // action: 'read',
            // resource: 'Auth',
          },
          {
            title: 'Thư mục kế hoạch',
            route: 'folder-plan-list',
            action: 'register_plans.folder',
            resource: 'RegisterPlan',
            // action: 'read',
            // resource: 'Auth',
          },
          {
            title: 'Đăng ký kế hoạch',
            route: 'register-plan-list',
            action: 'register_plans.index',
            resource: 'RegisterPlan',
          },
          {
            title: 'Phê duyệt kế hoạch',
            route: 'register-plan-list-approve',
            action: 'register_plans.approved',
            resource: 'RegisterPlan',
          },
          {
            title: 'Theo dõi kế hoạch',
            route: 'register-plan-statistical',
            action: 'register_plans.statistical',
            resource: 'RegisterPlan',
          },
        ],
      },
      {
        title: 'Quản lý tin bán ',
        icon: 'PieChartIcon',
        action: '',
        children: [
          {
            title: 'Giá tin bán',
            route: 'category-price-list',
            action: 'sell_news.category_price_list',
            resource: 'SellNews',
          },
          {
            title: 'Đơn vị mua tin',
            route: 'unit-buy-list',
            action: 'sell_news.unit_buy_list',
            resource: 'SellNews',
          },
          {
            title: 'Quản lý tin bán',
            route: 'sell-news-list',
            action: 'sell_news.list',
            resource: 'SellNews',
          },
          {
            title: 'Lịch sử nạp tiền momo',
            route: 'momo-history-list',
            action: 'sell_news.list',
            resource: 'SellNews',
          },
          // {
          //   title: 'Thư mục kế hoạch',
          //   route: 'folder-plan-list',
          //   action: 'register_plans.folder',
          //   resource: 'RegisterPlan',
          //   // action: 'read',
          //   // resource: 'Auth',
          // },
          // {
          //   title: 'Đăng ký kế hoạch',
          //   route: 'register-plan-list',
          //   action: 'register_plans.index',
          //   resource: 'RegisterPlan',
          // },
          // {
          //   title: 'Phê duyệt kế hoạch',
          //   route: 'register-plan-list-approve',
          //   action: 'register_plans.approved',
          //   resource: 'RegisterPlan',
          // },
          // {
          //   title: 'Theo dõi kế hoạch',
          //   route: 'register-plan-statistical',
          //   action: 'register_plans.statistical',
          //   resource: 'RegisterPlan',
          // },
        ],
      },
    ],
  },
  {
    header: 'Quản lý tài nguyên',
    children: [
      {
        title: 'General Categories',
        icon: 'FileTextIcon',
        action: null,
        resource: 'Manufacturer',
        children: [
          {
            title: 'Manufacturer',
            route: 'manufacturers-list',
            action: 'manufacturer.index',
            resource: 'Manufacturers',
          },
          {
            title: 'Provider',
            route: 'providers-list',
            action: 'manufacturer.provider_index',
            resource: 'Manufacturers',
          },
          {
            title: 'Models',
            route: 'models-list',
            action: 'manufacturer.model_index',
            resource: 'Manufacturers',
          },
          {
            title: 'Countries',
            route: 'country-list',
            action: 'manufacturer.country_index',
            resource: 'Manufacturers',
          },
        ],
      },
      {
        title: 'Quản lý thiết bị',
        icon: 'ToolIcon',
        action: null,
        resource: ['Devices'],
        children: [
          {
            title: 'Danh mục phân loại thiết bị',
            route: 'category_type_device-list',
            action: 'devices.category_type_device_index',
            resource: 'Devices',
          },
          {
            title: 'Danh sách thiết bị',
            route: 'devices-list',
            action: 'devices.index',
            resource: 'Devices',
          },
          {
            title: 'Danh sách sửa chữa',
            route: 'repairs-list',
            action: 'devices.repair_index',
            resource: 'Devices',
          },
          {
            title: 'Danh sách mượn',
            route: 'borrows-list',
            action: 'devices.borrow_index',
            resource: 'Devices',
          },
          {
            title: 'Duyệt mượn thiết bị',
            route: 'borrows-list-approve',
            action: 'devices.borrow_approved',
            resource: 'Devices',
          },
          {
            title: 'Báo hỏng thiết bị  phòng thu',
            route: 'repairs-studio-list',
            action: 'studios.require_repair',
            resource: 'Studios',
          },
          {
            title: 'Duyệt báo hỏng thiết bị phòng thu',
            route: 'repairs-list-approve',
            action: 'studios.approved_repair',
            resource: 'Studios',
          },
          {
            title: 'Thống kê',
            route: 'devices-statistical',
            action: 'devices.statistical',
            resource: 'Devices',
          },
        ],
      },
      {
        title: 'Quản lý phòng thu',
        icon: 'AirplayIcon',
        action: null,
        resource: ['Studios'],
        children: [
          {
            title: 'Danh sách phòng thu',
            route: 'studio-list',
            action: 'studios.index',
            resource: 'Studios',
          },
          {
            title: 'Sử dụng phòng thu',
            route: 'studio-list-book',
            action: 'studios.book',
            resource: 'Studios',
          },
          {
            title: 'Duyệt sử dụng phòng thu',
            route: 'studio-list-book-approve',
            action: 'studios.book_approve',
            resource: 'Studios',
          },
          {
            title: 'Theo dõi sử dụng phòng thu',
            route: 'studio-calendar',
            action: 'studios.calendar_list',
            resource: 'Studios',
          },
          {
            title: 'Thống kê',
            route: 'studio-statistical',
            action: 'studios.statistical',
            resource: 'Studios',
          },
        ],
      },
      {
        title: 'Quản lý xe lưu động',
        icon: 'TruckIcon',
        action: null,
        resource: ['MobileVehicle'],
        children: [
          {
            title: 'Danh sách xe lưu động',
            route: 'mobile-vehicle-list',
            action: 'mobile_vehicle.index',
            resource: 'MobileVehicle',
          },
          {
            title: 'Mượn xe thu lưu động',
            route: 'mobile-vehicle-list-book',
            action: 'mobile_vehicle.book',
            resource: 'MobileVehicle',
          },
          {
            title: 'Duyệt sử dụng xe thu lưu động',
            route: 'mobile-vehicle-list-book-approve',
            action: 'mobile_vehicle.book_approve',
            resource: 'MobileVehicle',
          },
          {
            title: 'Thống kê',
            route: 'mobile-vehicle-statistical',
            action: 'mobile_vehicle.statistical',
            resource: 'MobileVehicle',
          },
        ],
      },
      {
        title: 'Thiết lập form',
        icon: 'SettingsIcon',
        action: null,
        resource: [''],
        children: [
          {
            title: 'Form mượn thiết bị',
            route: 'device-form-setting',
            action: 'devices.form-setting',
            resource: 'Devices',
          },
          {
            title: 'Form mượn phòng thu',
            route: 'studio-form-setting',
            action: 'studios.form_setting',
            resource: 'Studios',
          },
          {
            title: 'Form đăng ký mượn xe',
            route: 'mobile-vehicle-form-setting',
            action: 'mobile_vehicle.form_setting',
            resource: 'MobileVehicle',
          },
        ],
      },
    ],
  },
  {
    header: 'Quản lý công việc',
    children: [
      {
        title: 'CategoryWork',
        route: 'category-work-list',
        action: 'category_works.index',
        resource: 'CategoryWork',
      },
      {
        title: 'ListWorkCreated',
        route: 'work-list',
        action: 'list_works.index',
        resource: 'ListWork',
        childRoutes: ['work-edit'],
      },
      {
        title: 'ListWorkAssigned',
        route: 'work-list-assigned',
        action: 'list_works.assigned',
        resource: 'ListWork',
        childRoutes: ['work-edit-assigned'],
      },
      {
        title: 'ListWorkCollaborators',
        route: 'work-list-collaborator',
        action: 'list_works.collaborator',
        resource: 'ListWork',
      },
    ],
  },
  {
    header: 'Media files',
    children: [
      {
        title: 'Danh sách files',
        route: 'files-list',
        icon: 'FileTextIcon',
        action: 'files.index',
        resource: 'Files',
      },
      {
        title: 'Danh sách dalet',
        route: 'files-dalet',
        icon: 'FileTextIcon',
        action: 'files.indexDalet',
        resource: 'Files',
      },
      {
        title: 'Quản lý MAM',
        icon: 'SettingsIcon',
        action: null,
        resource: [''],
        children: [
          {
            title: 'MAM Acounts',
            route: 'files-mam-account',
            action: 'files.mam_accounts.index',
            resource: 'Files',
          },
          {
            title: 'MAM Group Account',
            route: 'files-mam-user-account',
            action: 'files.mam_group_account.index',
            resource: 'Files',
          },
        ],
      },
    ],
  },
  {
    header: 'Social Livestream',
    children: [
      {
        title: 'Danh sách livestream',
        route: 'social-list',
        icon: 'DribbbleIcon',
        action: 'social.livestream',
        resource: 'Social',
      },
      {
        title: 'Lịch sử livestream',
        route: 'social-list-statistical',
        icon: 'DribbbleIcon',
        action: 'social.livestream',
        resource: 'Social',
      },
      {
        title: 'Bài viết trên fanpage',
        route: 'facebook-list',
        icon: 'DribbbleIcon',
        action: 'social.livestream',
        resource: 'Social',
      },
      {
        title: 'Hẹn giờ xuất bản',
        route: 'facebook-timer-list',
        icon: 'DribbbleIcon',
        action: 'social.livestream',
        resource: 'Social',
      },
    ],
  },
  {
    header: 'User & Permission',
    children: [
      {
        title: 'User',
        icon: 'UserIcon',
        route: 'users-list',
        action: 'user.index',
        resource: 'User',
      },
      {
        title: 'User Group',
        icon: 'UsersIcon',
        route: 'groups-list',
        action: 'group.index',
        resource: 'Group',
      },
      {
        title: 'Role',
        icon: 'UsersIcon',
        route: 'roles-list',
        action: 'role.index',
        resource: 'Role',
      },
      {
        title: 'Permission',
        icon: 'ShieldIcon',
        route: 'permissions-list',
        action: 'permission.index',
        resource: 'Permission',
      },
      {
        title: 'Module',
        icon: 'BoxIcon',
        route: 'modules-list',
        action: 'module.index',
        resource: 'Module',
      },
      {
        title: 'Department',
        icon: 'FolderIcon',
        route: 'departments-list',
        action: 'department.index',
        resource: 'Department',
      },
      {
        title: 'Position',
        icon: 'FolderIcon',
        route: 'positions-list',
        action: 'position.index',
        resource: 'Position',
      },
    ],
  },

  {
    header: 'System',
    children: [
      {
        title: 'Thông báo',
        icon: 'BellIcon',
        action: null,
        resource: 'Notification',
        children: [
          {
            title: 'Thông báo hệ thống',
            route: 'notification-list',
            action: 'notification.index',
            resource: 'Notification',
          },
          {
            title: 'Thông báo cá nhân',
            route: 'notification-personal',
            action: 'read',
            resource: 'Auth',
          },
        ],
      },
      {
        title: 'Log',
        icon: 'ActivityIcon',
        action: null,
        resource: 'Log',
        children: [
          {
            title: 'Auth Log',
            route: 'logs-auth',
            action: 'log.auth',
            resource: 'Log',
          },
          {
            title: 'Activity Log',
            route: 'logs-activity',
            action: 'log.activity',
            resource: 'Log',
          },
          {
            title: 'Article Log',
            route: 'article-log',
            action: 'article.log',
            resource: 'Article',
          },
          {
            title: 'File Log',
            route: 'logs-file',
            action: 'log.file',
            resource: 'Log',
          },
          {
            title: 'Audio Editing Log',
            route: 'logs-audio-editing',
            action: 'log.audio_editing',
            resource: 'Log',
          },
        ],
      },
      {
        title: 'Setting',
        icon: 'SettingsIcon',
        route: 'settings-list',
        action: 'setting.index',
        resource: 'Setting',
      },
    ],
  },

  // {
  //   header: 'General Setting',

  //   children: [
  //     {
  //       title: 'General Categories',
  //       icon: 'FileTextIcon',
  //       action: null,
  //       resource: 'Article',
  //       children: [
  //         {
  //           title: 'Manufacturer',
  //           route: 'manufacturers-list',
  //           action: 'manufacturer.index',
  //           resource: 'Manufacturers',
  //         },
  //         {
  //           title: 'Provider',
  //           route: 'providers-list',
  //           action: 'manufacturer.provider_index',
  //           resource: 'Manufacturers',
  //         },
  //         {
  //           title: 'Models',
  //           route: 'models-list',
  //           action: 'manufacturer.model_index',
  //           resource: 'Manufacturers',
  //         },
  //         {
  //           title: 'Countries',
  //           route: 'country-list',
  //           action: 'manufacturer.country_index',
  //           resource: 'Manufacturers',
  //         },
  //       ],
  //     },
  //   ],
  // },
];
